import React from 'react';
import { Card } from '../components/UI/Card';
export const NetworkingGuide = () => {
  const steps = [{
    number: '1️⃣',
    title: 'Set Your Compass – What Do You Want?',
    content: <div className="space-y-4" data-id="element-3359">
          <p data-id="element-3360">Instead of "I must network more," ask:</p>
          <ul className="space-y-2" data-id="element-3361">
            <li className="flex items-start" data-id="element-3362">
              <span className="mr-2" data-id="element-3363">🔍</span>
              <span data-id="element-3364">What excites me about connecting with others?</span>
            </li>
            <li className="flex items-start" data-id="element-3365">
              <span className="mr-2" data-id="element-3366">🎯</span>
              <span data-id="element-3367">
                Am I seeking mentorship, collaboration, opportunities, or just
                inspiration?
              </span>
            </li>
            <li className="flex items-start" data-id="element-3368">
              <span className="mr-2" data-id="element-3369">💎</span>
              <span data-id="element-3370">What unique value do I bring into a conversation?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3371">
            <span className="mr-2" data-id="element-3372">✍️</span>
            <span data-id="element-3373">
              Exercise: Write 3 things you hope to gain from networking — and 3
              things you can give.
            </span>
          </p>
        </div>
  }, {
    number: '2️⃣',
    title: 'Design Your Introduction (Your Story in 30 Seconds)',
    content: <div className="space-y-4" data-id="element-3374">
          <p data-id="element-3375">
            Networking starts with clarity. But clarity doesn't mean rigidity.
          </p>
          <ul className="space-y-2" data-id="element-3376">
            <li className="flex items-start" data-id="element-3377">
              <span className="mr-2" data-id="element-3378">👤</span>
              <span data-id="element-3379">Who am I? (roles, passions, projects)</span>
            </li>
            <li className="flex items-start" data-id="element-3380">
              <span className="mr-2" data-id="element-3381">🌱</span>
              <span data-id="element-3382">What drives me? (purpose, values, interests)</span>
            </li>
            <li className="flex items-start" data-id="element-3383">
              <span className="mr-2" data-id="element-3384">🔗</span>
              <span data-id="element-3385">Who do I want to connect with right now?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3386">
            <span className="mr-2" data-id="element-3387">🎤</span>
            <span data-id="element-3388">
              Activity: Draft 2-3 "micro-intros" you can switch between (for
              events, LinkedIn, casual chats).
            </span>
          </p>
        </div>
  }, {
    number: '3️⃣',
    title: 'Choose Your Arena – Where Will You Play?',
    content: <div className="space-y-4" data-id="element-3389">
          <p data-id="element-3390">Networking happens everywhere:</p>
          <ul className="space-y-2" data-id="element-3391">
            <li className="flex items-start" data-id="element-3392">
              <span className="mr-2" data-id="element-3393">🎙</span>
              <span data-id="element-3394">Events & salons</span>
            </li>
            <li className="flex items-start" data-id="element-3395">
              <span className="mr-2" data-id="element-3396">📩</span>
              <span data-id="element-3397">DMs & email outreach</span>
            </li>
            <li className="flex items-start" data-id="element-3398">
              <span className="mr-2" data-id="element-3399">🌍</span>
              <span data-id="element-3400">Online communities & forums</span>
            </li>
            <li className="flex items-start" data-id="element-3401">
              <span className="mr-2" data-id="element-3402">☕</span>
              <span data-id="element-3403">Coffee chats</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3404">
            <span className="mr-2" data-id="element-3405">🧭</span>
            <span data-id="element-3406">
              Prompt: Where do you already feel most comfortable starting? Where
              do you want to stretch yourself?
            </span>
          </p>
        </div>
  }, {
    number: '4️⃣',
    title: 'Practice the First Move',
    content: <div className="space-y-4" data-id="element-3407">
          <p data-id="element-3408">Instead of waiting for serendipity, design it.</p>
          <ul className="space-y-2" data-id="element-3409">
            <li data-id="element-3410">
              <strong data-id="element-3411">Warm path:</strong> Ask someone you know for an intro.
            </li>
            <li data-id="element-3412">
              <strong data-id="element-3413">Curious path:</strong> Reach out with a thoughtful
              question.
            </li>
            <li data-id="element-3414">
              <strong data-id="element-3415">Bold path:</strong> DM someone you admire with a specific
              compliment or idea.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3416">
            <span className="mr-2" data-id="element-3417">💡</span>
            <span data-id="element-3418">
              Challenge: This week, make 2 connections: one warm intro, one bold
              outreach.
            </span>
          </p>
        </div>
  }, {
    number: '5️⃣',
    title: 'Build Trust, Not Just Contacts',
    content: <div className="space-y-4" data-id="element-3419">
          <p data-id="element-3420">Think about conversations as bridges, not transactions.</p>
          <ul className="space-y-2" data-id="element-3421">
            <li className="flex items-start" data-id="element-3422">
              <span className="mr-2" data-id="element-3423">👂</span>
              <span data-id="element-3424">Listen deeply.</span>
            </li>
            <li className="flex items-start" data-id="element-3425">
              <span className="mr-2" data-id="element-3426">🎁</span>
              <span data-id="element-3427">
                Offer something of value (resource, insight, connection).
              </span>
            </li>
            <li className="flex items-start" data-id="element-3428">
              <span className="mr-2" data-id="element-3429">🔄</span>
              <span data-id="element-3430">
                Follow up quickly with gratitude + a simple next step.
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3431">
            <span className="mr-2" data-id="element-3432">✨</span>
            <span data-id="element-3433">
              Reflection: Recall the last time someone made you feel heard. How
              can you replicate that in your networking?
            </span>
          </p>
        </div>
  }, {
    number: '6️⃣',
    title: 'Keep the Web Alive',
    content: <div className="space-y-4" data-id="element-3434">
          <p data-id="element-3435">A network is like a garden — it needs tending.</p>
          <ul className="space-y-2" data-id="element-3436">
            <li className="flex items-start" data-id="element-3437">
              <span className="mr-2" data-id="element-3438">🌱</span>
              <span data-id="element-3439">Share updates about your journey.</span>
            </li>
            <li className="flex items-start" data-id="element-3440">
              <span className="mr-2" data-id="element-3441">🎉</span>
              <span data-id="element-3442">Celebrate others' wins.</span>
            </li>
            <li className="flex items-start" data-id="element-3443">
              <span className="mr-2" data-id="element-3444">🔗</span>
              <span data-id="element-3445">Connect people to each other.</span>
            </li>
            <li className="flex items-start" data-id="element-3446">
              <span className="mr-2" data-id="element-3447">📒</span>
              <span data-id="element-3448">
                Track relationships (Notion, Airtable, CRM, even your Notes
                app).
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3449">
            <span className="mr-2" data-id="element-3450">🛠</span>
            <span data-id="element-3451">
              Action: Create your personal "Connection Tracker" — 5 people to
              re-engage with this month.
            </span>
          </p>
        </div>
  }, {
    number: '7️⃣',
    title: 'Your Rules, Your Rhythm',
    content: <div className="space-y-4" data-id="element-3452">
          <p data-id="element-3453">
            Forget the idea that networking = constant hustle. It's about
            finding your rhythm:
          </p>
          <ul className="space-y-2" data-id="element-3454">
            <li data-id="element-3455">
              <strong data-id="element-3456">Monthly:</strong> New introductions.
            </li>
            <li data-id="element-3457">
              <strong data-id="element-3458">Weekly:</strong> Small touchpoints.
            </li>
            <li data-id="element-3459">
              <strong data-id="element-3460">Daily:</strong> One authentic conversation.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3461">
            <span className="mr-2" data-id="element-3462">📓</span>
            <span data-id="element-3463">
              Design Your Rhythm: What feels sustainable and energizing for you?
            </span>
          </p>
        </div>
  }];
  return <div className="pt-20" data-id="element-3464">
      <section className="py-16 bg-secondary/5" data-id="element-3465">
        <div className="container mx-auto px-4" data-id="element-3466">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-3467">
            🌐 The Networking Guide: Build Connections That Matter
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-3468">
            This is not a rulebook. It's a playground for you to explore how you
            connect, what feels authentic, and where you want your network to
            take you.
          </p>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto mt-4" data-id="element-3469">
            You'll find reflection prompts, mini-experiments, and action
            challenges — designed so you shape your own networking style.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-3470">
        <div className="container mx-auto px-4" data-id="element-3471">
          <div className="space-y-12" data-id="element-3472">
            {steps.map((step, index) => <Card key={index} className="p-6 border-2 border-gray-200" data-id="element-3473">
                <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-3474">
                  <div className="text-3xl font-bold text-primary" data-id="element-3475">
                    {step.number}
                  </div>
                  <div className="flex-1" data-id="element-3476">
                    <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-3477">
                      {step.title}
                    </h2>
                    <div className="text-secondary" data-id="element-3478">{step.content}</div>
                  </div>
                </div>
              </Card>)}
            <Card className="p-6 border-2 border-gray-200" data-id="element-3479">
              <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-3480">
                ⚡ Quick Experiments (Choose Your Path)
              </h2>
              <div className="space-y-4" data-id="element-3481">
                <p className="flex items-start" data-id="element-3482">
                  <span className="mr-2 text-xl" data-id="element-3483">🎭</span>
                  <span data-id="element-3484">
                    <strong data-id="element-3485">The Actor's Game:</strong> Try introducing yourself
                    3 different ways in one week. Notice what lands.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-3486">
                  <span className="mr-2 text-xl" data-id="element-3487">📩</span>
                  <span data-id="element-3488">
                    <strong data-id="element-3489">The 5-Message Sprint:</strong> Send 5 personalized
                    messages in 5 days. Track replies.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-3490">
                  <span className="mr-2 text-xl" data-id="element-3491">☕</span>
                  <span data-id="element-3492">
                    <strong data-id="element-3493">The Coffee Challenge:</strong> Book 2 chats with
                    people outside your usual circle this month.
                  </span>
                </p>
              </div>
              <p className="mt-6 font-medium" data-id="element-3494">
                👉 By the end of this guide, you don't just "learn how to
                network." You invent your own networking practice — one that
                feels natural, generous, and effective.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>;
};